import React from "react";
import PropTypes from "prop-types";

/**
 * JSX component version - use this in React components for styled currency display
 * Applies the custom font family automatically
 * @param {string|number} amount - The amount to display
 * @param {string} currencySymbol - The currency symbol
 * @returns {JSX.Element} Formatted currency component
 */
export const CurrencyDisplay = ({ amount, currencySymbol = "D" }) => {
  return (
    <span className="aed-currency">
      {currencySymbol} {amount}
    </span>
  );
};

CurrencyDisplay.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currencySymbol: PropTypes.string
};
